import { render } from "./CardUI.vue?vue&type=template&id=20ac7cf6"
import script from "./CardUI.vue?vue&type=script&lang=js"
export * from "./CardUI.vue?vue&type=script&lang=js"

import "./CardUI.vue?vue&type=style&index=0&id=20ac7cf6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__